import styled from 'styled-components'
import tw from 'tailwind.macro'

const StCredits = styled.div`
  text-align: center;
  padding: 1rem;
  background-color: tomato;
  color: black;
  .creditsWrapper {
    ${tw`max-w-sm mx-auto p-4`}
  }
  h2 {
    line-height: 1;
    margin-bottom: 1rem;
  }

  p {
    text-transform: uppercase;
    font-size: 1rem;
  }
  strong {
    font-weight: bold;
    display: block;
  }
`

export { StCredits }
